import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { RouterLink } from "@angular/router";

import { PATHS } from "@app/core/constants/path.const";
import { SvgIconsService } from "@app/core/services/svg-icons.service";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "under-ui-password-expiry-banner",
  standalone: true,
  imports: [TranslateModule, RouterLink, MatIconModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./password-expiry-banner.component.html",
  styleUrl: "./password-expiry-banner.component.scss",
})
export class PasswordExpiryBannerComponent {
  private readonly svgIconsService = inject(SvgIconsService);

  @Input({ required: true }) daysRemaining!: number;
  @Output() readonly dismissed = new EventEmitter<void>();

  protected readonly profilePath = `/${PATHS.profile.path}`;

  constructor() {
    this.svgIconsService.registerIcons(["cross"]);
  }

  onDismiss(): void {
    this.dismissed.emit();
  }
}
